<template>
  <div>
    <!-- 订单列表弹框开始 -->
    <el-dialog :close-on-click-modal="false"
      title="订单列表"
      :visible.sync="orderListDialogVisible"
      :before-close="orderListHandleClose"
      width="64.6%"
      center
      top="15vh"
    >
      <el-divider></el-divider>
      <div class="contentBox">
        <div class="titleStyle">
          <span>景区名称</span>
          <span>{{ name }}</span>
        </div>
      </div>
      <div>
        <el-table
          :data="tableData"
          :header-cell-style="tableHeaderColor"
          :cell-style="cellStyle"
          style="width: 100%"
        >
          <el-table-column prop="ProductName" label="产品名称"></el-table-column>
          <el-table-column prop="AgentPrice" label="代理价"></el-table-column>
          <el-table-column prop="address" label="消费有效期" width="350px" >
            <template slot-scope="scope">
              <div class="tableDataBox" v-if="scope.row.type=='1'">
                <div>游玩日期:</div>
                <div class="tableData">
                  <el-date-picker v-model="valueTime" type="date" placeholder="选择日期"  value-format="yyyy-MM-dd" ></el-date-picker>
                </div>
              </div>
              <div class="tableDataBox" v-else >
                <div class="tableData">
                   <span>{{ scope.row.ConsumeBeginDate }}--{{ scope.row.ConsumeEndDate }}</span>
                </div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="address" label="支持退货">
            <template slot-scope="scope">
              <img src="@/images/distributor/kt.png" alt v-if="scope.row.ReturnFlag=='0'" />
              <img src="@/images/distributor/bkt.png" alt v-if="scope.row.ReturnFlag=='1'" />
            </template>
          </el-table-column>
          <el-table-column label="购买数量">
            <template>
              <div class="tableInp">
                <el-input 
                  placeholder="数量" 
                  v-model.number="num" 
                  type="number"
                  :min="0"
                  :disabled="disable"
                  @input="handleNumInput"
                ></el-input>
              </div>
            </template>
          </el-table-column>
          <el-table-column  label="金额小计">
            <template slot-scope="scope">
              {{ (scope.row.AgentPrice * num).toFixed(2) }}
            </template>
          </el-table-column>
          <el-table-column prop="address" label="操作">
            <template slot-scope="scope">
              <el-button type="text" style="color: #E74C3C;">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="bottonForm">
        <el-form ref="form" :model="form" label-width="80px">
          <el-form-item label="备注:">
            <el-input type="textarea" v-model="form.remark" placeholder="请输入内容"></el-input>
          </el-form-item>
          <div class="itemOne">
            <div>
              <el-form-item label="金额共计:">
                <el-input v-model="Totalamount" placeholder="总金额">
                  <template>
                    <slot slot="suffix" class="input-slot">元</slot>
                  </template>
                </el-input>
              </el-form-item>
            </div>
            <div v-if="card_access=='1' || age_range_start || province_name">
              <el-form-item label="身份证:">
                <span class="xingA">*</span>
                <el-input v-model="idCard" placeholder="请输入身份证号"></el-input>
              </el-form-item>
            </div>
            <div>
              <el-form-item label="手机号:">
                <span class="xingA">*</span>
                <el-input v-model="phone" placeholder="请输入接收验证码的手机号"></el-input>
              </el-form-item>
              <el-form-item>
                <span></span>
                <el-button @click="transmit">结算发送订单验证码</el-button>
              </el-form-item>
            </div>
           
          </div>
        </el-form>
      </div>
    </el-dialog>
    <!-- 订单列表弹框结束 -->
  </div>
</template>

<script>
import {getProductInfo,addDistributorOrder} from '@/request/distributor.js'
import {Message} from 'element-ui'
import addressCodes from './addressCodes'
export default {
  props:['name','goodId'],
  data() {
    return {
      orderListDialogVisible: false, // 订单列表
      tableData: [
      ],
      form: {
        remark: ""
      },
      valueTime: "",
      num:'1',
      price:"",
      phone:'',
      idCard:'',
      card_access:'',
      flow:true,
      age_range_start:'',
      age_range_end:'',
      disable:'',
      province_name: "",
      city_name: "",
      addressCodes: addressCodes.addressCodes
    };
  },
  computed:{
    Totalamount(){
      // this.num   
      let price = 0
      this.tableData.map(item=>{
        price = item.AgentPrice * this.num
      })
      return price.toFixed(2)
    }
  },
  created(){
    this.sceniclist()
  },
  methods: {
    handleNumInput() {
      // 确保输入值不能为负数
      if (this.num < 0 || this.num === null || this.num === undefined) {
        this.num = 0;
      }
      // 如果是字符串，转换为数字
      if (typeof this.num === 'string') {
        const num = parseFloat(this.num);
        if (isNaN(num) || num < 0) {
          this.num = 0;
        } else {
          this.num = num;
        }
      }
    },
       sceniclist(){
        let data = {
          token:window.sessionStorage.getItem('Token'),
          goods_id:this.goodId,
        }
        getProductInfo(data).then(res=>{
          if(res.data.status=='ok'){
            this.tableData.push(res.data.result)
            this.card_access = this.tableData[0].card_access
            this.age_range_start = res.data.result.age_range_start
            this.age_range_end = res.data.result.age_range_end
            this.province_name = res.data.result.province_name;
            this.city_name = res.data.result.city_name;
            this.card_access = this.tableData[0].card_access;
            if(this.card_access=='1'){
              this.disable = true
            }else{
              this.disable = false
            }
            if( this.age_range_start){
              this.disable = true
            }else{
              this.disable = false
            }
            if (this.province_name) {
              this.disable = true;
            } else {
              this.disable = false;
            }
          }
        })
    },
    // 发送订单
    transmit(){
      if(this.flow){
        this.flow = false
      }else{
        return false
      }
      let data = {
        token:window.sessionStorage.getItem('Token'),
        goods_id:this.goodId,
        num:this.num,
        phone:this.phone,
        scenicid:this.tableData[0].ScenicID,
        date:this.valueTime,
        idcard:this.idCard,
        remark:this.form.remark
      }
      if(this.card_access=='1'||this.age_range_start||this.province_name){
        if(this.idCard==''){
          Message.error('请输入身份证')
          this.flow = true
          return false
        }else{
          let trflow = this.checkIdCard(this.idCard);
          if(trflow){
            if(this.age_range_start&&this.age_range_end){
              let ages = this.calculateAge(this.idCard)
              let counts = this.checkInRange(ages,this.age_range_start,this.age_range_end)
              if(counts){
               
              }else{
                  this.flow = true
                  Message.error('年龄不符合购买产品限制')
                  return false
              }
            }
            if(this.province_name&&this.city_name){
               // 提取前6位地址码
              const addressCode = this.idCard.substring(0, 6);
              // 提取省份代码（前2位）
              const provinceCode = addressCode.substring(0, 2);
              // 提取城市代码（前4位）
              const cityCode = addressCode.substring(0, 4);
              const province = this.addressCodes[provinceCode] || '未知省份';
              const city = this.addressCodes[cityCode] || '未知城市';
              console.log(province,city)
              if(this.province_name==province){
              }else{
                Message.error('不符合地域限制')
                return false
              }
              if(this.city_name==city){
              }else{
                Message.error('不符合地域限制')
                return false
              }
            }
          }else{
            this.flow = true
            Message.error('身份证号码不正确')
            return false
          }
        }
      }
      addDistributorOrder(data).then(res=>{
        console.log(res.data)
        if(res.data.status=='ok'){
          Message.success(res.data.msg)
          this.$emit('closeList')
          this.flow = true
        }else{
          Message.error(res.data.msg);
          this.flow = true
        }
      })
    },
    checkInRange(num, min, max) {
      // 通用方法，可传入不同的参数
      return num >= min && num <= max;
    },
    calculateAge(idCard){
				 let birthYear, birthMonth, birthDay;
				  
				  // 18位身份证号码的第7-14位是出生日期
				  birthYear = parseInt(idCard.substring(6, 10));
				  birthMonth = parseInt(idCard.substring(10, 12));
				  birthDay = parseInt(idCard.substring(12, 14));
				  
				  // 格式化生日显示
				  this.birthday = `${birthYear}年${birthMonth}月${birthDay}日`;
				  
				  // 获取当前日期
				  const today = new Date();
				  const currentYear = today.getFullYear();
				  const currentMonth = today.getMonth() + 1; // 月份从0开始，所以加1
				  const currentDay = today.getDate();
				  
				  // 计算年龄
				  let age = currentYear - birthYear;
				  
				  // 如果当前月份小于出生月份，年龄减1
				  if (currentMonth < birthMonth) {
					age--;
				  } 
				  // 如果月份相同但日期小于出生日，年龄减1
				  else if (currentMonth === birthMonth && currentDay < birthDay) {
					age--;
				  }
        return age
			},
    // 身份证长度校验
    checkIdCard(idCard){
        var reg = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
        if(reg.test(idCard)){
            return true;
        }else{
            return false;
        }
    },
    // 订单列表
    orderList() {
      this.orderListDialogVisible = true;
    },
    // 订单列表X
    orderListHandleClose() {
      this.$emit('closeList')
      this.orderListDialogVisible = false;
    },
    // 表头设置
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      return this.utils.tableHeaderColor({
        row,
        column,
        rowIndex,
        columnIndex
      });
    },
    cellStyle({ row, rowIndex }) {
      return this.utils.cellStyle({
        row,
        rowIndex
      });
    }
  }
};
</script>

<style lang='less' scoped>
.bottonForm {
    margin-top: 20px;
  .itemOne {
    display: flex;
    // justify-content: space-between;
    > div:last-child {
      display: flex;
      .el-input {
        width: 256px;
      }
      .el-button {
        width: 180px;
        background: #246deb;
        border-radius: 4px;
        font-family: "OPPOSans";
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        color: #ffffff;
        border: none;
        margin-left: -60px;
      }
    }
  }
  .el-form-item {
    position: relative;
  }
  .xingA {
    position: absolute;
    top: 0px;
    left: -63px;
    color: #e74c3c;
  }
}
.tableInp {
  .el-input {
    width: 100px;
    height: 30px;
  }
  /deep/.el-input__inner {
    height: 30px;
    line-height: 30px;
    background: #f7f7fa;
    border-radius: 4px;
    border: none;
    text-align: center;
  }
}
.tableDataBox {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  .tableData {
    /deep/.el-date-editor.el-input,
    .el-date-editor.el-input__inner {
      width: 200px;
      height: 30px;
      background: #f7f7fa;
      border-radius: 4px;
      margin-left: 10px;
    }
    /deep/.el-input__inner {
      -webkit-appearance: none;
      background-color: #f7f7fa;
      border-radius: 4px;
      border: 1px solid #dcdfe6;
      box-sizing: border-box;
      color: #606266;
      display: inline-block;
      font-size: inherit;
      height: 30px;
      line-height: 30px;
      outline: 0;
      //   padding: 0 15px;
      transition: border-color 0.2s cubic-bezier(0.645, 0.045, 0.355, 1);
      width: 100%;
      border: none;
    }
    /deep/.el-input__icon {
      height: 100%;
      width: 25px;
      text-align: center;
      transition: all 0.3s;
      line-height: 30px;
    }
  }
}
.contentBox {
  .titleStyle {
    margin-bottom: 20px;
    > span:nth-child(1) {
      font-family: "OPPOSans";
      font-style: normal;
      font-weight: 600;
      font-size: 14px;
      text-align: center;
      color: #000000;
      margin-right: 10px;
    }
    > span:nth-child(2) {
      font-family: "OPPOSans";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      text-align: center;
      color: #666666;
    }
  }
}
</style>